import type { MediaUploadHandle, MediaUploadKind } from "@tg/shared";
import { httpBaseFromWsUrl } from "./auth-api.js";

const requestUpload = async (
  wsUrl: string,
  file: File,
  kind: MediaUploadKind
): Promise<MediaUploadHandle> => {
  const base = httpBaseFromWsUrl(wsUrl);
  let response: Response;
  try {
    response = await fetch(`${base}/api/media/upload`, {
      method: "POST",
      headers: {
        "content-type": file.type || "application/octet-stream",
        "x-file-name-encoded": encodeURIComponent(file.name),
        "x-media-kind": kind
      },
      body: file
    });
  } catch (cause) {
    throw new Error(
      cause instanceof Error && cause.message.trim().length > 0
        ? `Не удалось загрузить файл: ${cause.message}`
        : "Не удалось загрузить файл."
    );
  }

  if (!response.ok) {
    const body = (await response.json().catch(() => null)) as { error?: string } | null;
    throw new Error(body?.error ?? `Upload failed with status ${response.status}`);
  }

  return (await response.json()) as MediaUploadHandle;
};

export const mediaApi = {
  uploadFile(wsUrl: string, file: File, kind: MediaUploadKind): Promise<MediaUploadHandle> {
    return requestUpload(wsUrl, file, kind);
  }
};
